import React, { Component } from 'react';
import IncreaseInput from "components/Components/UI/IncreaseInput";
import PropTypes from "prop-types";

class Guests extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    handleCallbackAdults = (childDataAdults) =>{
        this.props.parentCallAdult(childDataAdults);
    }

    handleCallbackChildren = (childDataChildren) =>{
        this.props.parentCallChildren(childDataChildren);
    }

    render() {

        const {
            deafultAdults, deafultChild
        } = this.props;

        return (
            <>
                <h5 className="tw-uppercase font-sp tw-mb-10 tw-text-left">Guests</h5>
                <IncreaseInput
                    textOne={'Adults'}
                    textTwo={'Over 12'}
                    className={'tw-mb-5'}
                    deafultText={this.props.deafultAdults}
                    parentCallback = {this.handleCallbackAdults}
                />
                <IncreaseInput
                    textOne={'Children'}
                    textTwo={'Under 12'}
                    deafultText={this.props.deafultChildren}
                    parentCallback = {this.handleCallbackChildren}
                />
            </>
        );
    }
}

Guests.defaultProps = {
    deafultAdults: 2,
    deafultChildren: 0,
}

Guests.propTypes = {
    deafultAdults: PropTypes.number,
    deafultChildren: PropTypes.number,
};

export default Guests;
